import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAddVideoMutation, useEditVideoMutation } from '../../redux/features/video/videoApi';
import Error from "../ui/Error";

const isValidYoutubeEmbedUrl = (url) => {
    const regex = /^https:\/\/www\.youtube\.com\/embed\/([a-zA-Z0-9_-]{11})$/;
    return regex.test(url);
}


export default function VideoAddForm({ handleOut }) {
    const { isEdit, data } = useSelector((state) => state.edit) || {};

    const [input, setInput] = useState({
        title: "",
        url: "",
        duration: "",
        views: "",
        description: ""
    });
    const [errorState, setError] = useState(false);
    const [addVideo, { isError, isSuccess }] = useAddVideoMutation();
    const [editVideo, { isError: isErrorEdit, isSuccess: isSuccessEdit }] = useEditVideoMutation();

    const changeHandler = (e) => {
        setInput((prev) => {
            return {
                ...prev,
                [e.target.name]: (e.target.value)
            }
        })
    }

    const submitHandler = (e) => {
        setError(false)
        e.preventDefault();

        if (isEdit) {
            editVideo({
                id: data?.id,
                data: { ...input }
            })
        } else {
            // check video url valid or not
            if (isValidYoutubeEmbedUrl(input.url)) {
                addVideo({
                    ...input,
                    createdAt: new Date().toISOString()
                })
            } else {
                setError("Video URL invalid. Should inset Youtube Embed URL")
            }
        }
    }
    // error state set 
    useEffect(() => {
        if (isError || isErrorEdit) { setError("There was and error") }
        if (isSuccess || isSuccessEdit) {
            handleOut(false)
        }

    }, [handleOut, isError, isErrorEdit, isSuccess, isSuccessEdit])

    useEffect(() => {
        isEdit && setInput(data)
    }, [data, isEdit])

    return (
        <>
            {errorState && <Error message={errorState} />}
            <form onSubmit={submitHandler} className="mt-5 p-6">
                <div className="mb-6">
                    <label htmlFor="title" className="block mb-2 text-sm font-medium text-white">Video title</label>
                    <input name='title' type="text" id="title" className="text-sm rounded-lg block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required
                        value={input.title}
                        onChange={changeHandler}
                    />
                </div>
                <div className="mb-6">
                    <label htmlFor="video-url" className="block mb-2 text-sm font-medium text-white">Video url</label>
                    <input type="text" id="video-url" name='url' className="text-sm rounded-lg block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required
                        value={input.url}
                        onChange={changeHandler}
                    />
                </div>
                <div className="grid gap-6 md:grid-cols-2">
                    <div className="mb-6">
                        <label htmlFor="duration" className="block mb-2 text-sm font-medium text-white">Duration</label>
                        <input type="text" id="duration" name='duration' className="text-sm rounded-lg block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required
                            value={input.duration}
                            onChange={changeHandler}
                        />
                    </div>
                    <div>
                        <label htmlFor="views" className="block mb-2 text-sm font-medium  text-white">Views</label>
                        <input type="text" id="views" name='views' className="text-sm rounded-lg block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required
                            value={input.views}
                            onChange={changeHandler}
                        />
                    </div>
                </div>
                <div className="mb-6">
                    <label htmlFor="description" className="block mb-2 text-sm font-medium text-white">Video Description</label>
                    <textarea type="text" id="description" name='description' className="text-sm rounded-lg block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required
                        value={input.description}
                        onChange={changeHandler}
                    />
                </div>

                <button type="submit" className="bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center focus:ring-blue-800">Submit</button>
            </form>
        </>
    )
};